/**
 * 共有リンク作成ダイアログ Step 1「渡す」カード用のイラスト。
 *
 * メタファ: 「あなた → 動画ファイル → 相手」の左→右フロー。
 * 並べた時にもう一方の {@link ShareReceiveIllust} と矢印の向きが反転して
 * 見えることが、3 択 (View / Download / Upload) の方向違いを瞬時に
 * 伝える鍵になる。
 *
 * - 線画ベース。色は currentColor で親要素のテキストカラーを継承する。
 * - 頭と肩の接続: cubic bezier の t=0.5 における y = 0.25·y_btm + 0.75·y_top。
 *   y_top = cy_head (頭の中心) にすると apex_y = cy_head + 1 になり、
 *   頭の底辺 (cy_head + r) と 1〜2px だけ重なって自然に繋がって見える。
 */
export function ShareSendIllust({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 200 100"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      <title>渡す</title>

      <g>
        <circle cx="22" cy="26" r="10" />
        <path d="M4 62 C 4 26, 40 26, 40 62" />
      </g>

      <g>
        <rect x="66" y="34" width="46" height="36" rx="4" />
        <path d="M106 34 V40 a4 4 0 0 0 4 4 H112" />
        <path d="M80 42 L96 52 L80 62 Z" fill="currentColor" stroke="none" />
      </g>

      <g>
        <path d="M122 52 H156" />
        <path d="M149 46 L156 52 L149 58" />
      </g>

      <g>
        <circle cx="178" cy="26" r="10" />
        <path d="M160 62 C 160 26, 196 26, 196 62" />
      </g>
    </svg>
  )
}
